import React, { Component } from "react";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";

import { keyRequestsStore } from "../store/store";
import GenerateKey from "./GenerateKey/GenerateKey.component";
import KeyHistory from "./KeyHistory/KeyHistory.component";

import Footer from "../../home/components/Footer/footer.component";

import "./KeyPage.component.scss";

class KeyPage extends Component {
    render() {
        return (
            <Provider store={keyRequestsStore}>
                <div id="KeyPage">
                    <Switch>
                        <Route
                            exact
                            path={"/configuration-key"}
                            component={GenerateKey}
                        />
                        <Route
                            path={"/configuration-key/history"}
                            component={KeyHistory}
                        />
                        <Route path={"/"} component={GenerateKey} />
                    </Switch>
                    <Footer />
                </div>
            </Provider>
        );
    }
}

export default KeyPage;
